/* ============================================================
   Lab Effects — Spotlight hero finder sheets.
   Click a path card → slide up the matching finder sheet.
   Close via the × button, the backdrop, or Esc. Vanilla JS;
   ported from the React prototype (app.jsx / finder.jsx).
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.leHeroBound) return;
    root.dataset.leHeroBound = "1";

    var sheet = root.querySelector("[data-le-fsheet]");
    if (!sheet) return;
    var cards = sheet.querySelectorAll("[data-le-sheet]");
    var lastFocus = null;

    function open(id) {
      var matched = null;
      cards.forEach(function (c) {
        var on = c.getAttribute("data-le-sheet") === id;
        c.classList.toggle("is-active", on);
        c.hidden = !on;
        if (on) matched = c;
      });
      if (!matched) return;
      lastFocus = document.activeElement;
      sheet.hidden = false;
      sheet.classList.add("is-mounted");
      void sheet.offsetWidth; // force reflow so the slide-up transition runs
      sheet.classList.add("is-open");
      if (window.LESheetLock) LESheetLock.lock();
      var closeBtn = matched.querySelector(".le-fsheet__close");
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!sheet.classList.contains("is-open")) return;
      sheet.classList.remove("is-open");
      if (window.LESheetLock) LESheetLock.unlock();
      var card = sheet.querySelector(".le-fsheet-card.is-active");
      var done = function () {
        sheet.classList.remove("is-mounted");
        sheet.hidden = true;
        cards.forEach(function (c) { c.classList.remove("is-active"); c.hidden = true; });
        if (card) card.removeEventListener("transitionend", done);
      };
      if (card) {
        card.addEventListener("transitionend", done);
        setTimeout(done, 360); // fallback if transitionend never fires
      } else { done(); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll("[data-le-finder]").forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        open(t.getAttribute("data-le-finder"));
      });
    });
    sheet.addEventListener("click", function (e) {
      if (e.target.closest("[data-le-fclose]")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  function boot() {
    document.querySelectorAll("[data-le-hero]").forEach(init);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  // Re-bind when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector("[data-le-hero]");
    if (r) init(r);
  });
})();
